import React from "react";

import { IDashboardContext } from "../../../contexts/dashboard-context";
import { showDialogAsync } from "../../dialog-queue";
import { ConfirmDialog } from "../../dialog/confirm";

import { labels } from "./labels";

export const showRestartProductDialogAsync = ({
	busyBlocker,
	dashboard,
	editor,
}: {
	busyBlocker: eXpress.IBalancedScope;
	dashboard: IDashboardContext;
	editor: eXpress.core.IEditor;
}) =>
	showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<ConfirmDialog
			cancelLabel={labels.goBack}
			titleLabel={labels.title}
			messageHtmlLabel={labels.message}
			messageHtmlReplacements={[editor.assets.photoSelection.length.toString()]}
			isOpen={isOpen}
			okLabel={labels.restart}
			onOk={() => resolve(true)}
			onCancel={() => resolve(false)}
		/>
	)).then((shouldRestart) => {
		if (shouldRestart) {
			// restart without refill
			const resetOptions = { refill: false };
			if (dashboard.canResetDefinition(resetOptions)) {
				return busyBlocker.during(dashboard.resetDefinitionAsync(resetOptions));
			}
		}

		return Promise.resolve();
	});
